// @flow
import { createSelector } from 'reselect';
import type { Payer } from '../user/user.types.js';

import { payerSelector } from '../user/user.selectors.js';

export const balanceByOrgListSelector = createSelector(
  payerSelector,
  (payer: Payer) => Object.keys(payer.balanceByOrg || {})
);
